import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "services/queryClient";

interface Order {
  id: string;
  note: string;
  setModalOpen: any;
}

export const useMarkOrderAsMissedMutation = ({
  id,
  note,
  setModalOpen,
}: any) => {
  return useMutation({
    mutationFn: () =>
      axiosInstance
        .post(`/orders/${id}/mark-as-missed`, { note: note })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["order"] });
      setModalOpen(false);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
